// Fetch the entitlement again from code that has no dispatch at hand. A team
// link (a coach or team code, a roster claim) or a team removal can start or
// end the Premium a coach's paid plan includes (dev call, 2026-10-07), and
// those requests live in plain service functions. fetchEntitlement remembers
// how to run itself on the app's store the first time the app fetches the
// entitlement (on load and at sign in), so every caller of those services gets
// the fresh answer without passing a dispatch in.

let rerun = null;

export const rememberEntitlementFetch = (run) => {
  rerun = typeof run === 'function' ? run : null;
};

// Best effort: resolves to the fresh entitlement, or null when the app has
// not fetched it yet or the request fails. Never throws.
export const refreshEntitlement = async () => {
  if (!rerun) return null;
  try {
    return await rerun();
  } catch {
    return null;
  }
};
